package com.downdogapp.client.singleton

enum class Platform {
  IOS,
  ANDROID,
  WEB
}
